// store
import {
  SET_LANG
} from "../actions/i18";

const state = {
  lang: localStorage.getItem("lang") || 'ru',
};

const getters = {
  lang: state => state.lang,
};

const actions = {
  [SET_LANG]: ({commit}, lang) => {
    commit(SET_LANG, lang);
  },
};

const mutations = {
  [SET_LANG]: (state, lang) => {
    localStorage.setItem("lang", lang);
    window.location.reload();
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
